const HIDDEN_FIELDS = {
  organizationId: {
    name: 'orgid',
    value: process.env.SERVICE_CLOUD_ORG_ID,
  },
} as const;

// Using variable with type annotation as substitute for satisfies keywork (not
// yet available in version of TypeScript we are using).
/* eslint-disable @typescript-eslint/no-unused-vars */
const typeCheck: Record<string, { name: string; value: string }> =
  HIDDEN_FIELDS;
/* eslint-enable @typescript-eslint/no-unused-vars */

export const HiddenFields = () => {
  return (
    <>
      {Object.values(HIDDEN_FIELDS).map(({ name, value }) => (
        <input key={name} type="hidden" name={name} value={value} />
      ))}
    </>
  );
};
